import axios from 'axios'

export default  {
  namespaced: true,

  state: {
    types: [],
  },

  mutations: {
    getTypesSuccess(state, types) {
      state.types = types
    },
  },

  actions: {
    getTypes({commit}) {
      return new Promise((resolve, reject) => {
        axios.get('/manufacturers/get-types')
          .then(res => {
            commit('getTypesSuccess', res.data.data.types)
            resolve(true)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getCompanieTypes({commit}) {
        return new Promise((resolve, reject) => {
          axios.get('/manufacturers/get-companie-types')
            .then(res => {
              commit('getTypesSuccess', res.data.data.types)
              resolve(true)
            })
            .catch(error => {
              reject(error)
            })
        })
      },

    find({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/manufacturers/${id}`)
          .then((res) => {
            resolve(res.data.data.manufacturer)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    create({commit}, manufacturerForm) {
      return new Promise((resolve, reject) => {
        axios
          .post('/manufacturers', manufacturerForm)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    update({commit}, manufacturerForm) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/manufacturers/${manufacturerForm.id}`, manufacturerForm)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    delete({commit}, manufacturerId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/manufacturers/${manufacturerId}`)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    restore({commit}, manufacturerId) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/manufacturers/${manufacturerId}/restore`)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    saveDocument({ commit }, documentForm) {
        return new Promise((resolve, reject) => {
            axios
                .post("/manufacturers/documents", documentForm, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then((res) => {
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    deleteDocument({ commit }, manufacturerDocumentId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/manufacturers/documents/${manufacturerDocumentId}`)
                .then((res) => {
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
  },

  getters: {
    types: (state) => state.types,
  },
}
